import React from 'react';
import { faCheckCircle, faScrewdriver } from '@fortawesome/free-solid-svg-icons';
import { FormGroup, Input } from 'reactstrap';
import { toast } from 'react-toastify';
import { BaseFormViewModel } from '../common/ViewModel';
import {
    FormLabel, onFieldChange, onReactSelectChanged, ToastMessage, ValidationErrorMessage,
} from '../common/forms/FormElements';
import { Department } from './Department';
import CommonContext, { ApiRoutes } from '../Common';
import SlideForm from '../common/forms/SlideForm';
import { util } from '../Util';
import { handleFormSaveError } from '../common/forms/ValidationError';

export class DepartmentForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();

        const stateBase = {
            department: this.props.department ?? new Department(),
            show: false,
            ...new BaseFormViewModel(),
        };

        this.state = stateBase;
        this.onSubmit = this.onSubmit.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentDidMount() {
        this.populateState();
    }

    onChange = onFieldChange.bind(this);

    onClose(response) {
        this.setState({ show: false });
        this.resetForm();
        this.context.setFormOpened(false);
        this.props.onClose(response);
    }

    onSelectChange = onReactSelectChanged.bind(this);

    onSubmit = async (e) => {
        const { department } = this.state;

        // Clear any fluent api errors
        this.setState({ errors: {}, saving: true });

        // Is this POST or PUT?
        const url = department.id
            ? ApiRoutes.department.update(department.id)
            : ApiRoutes.department.create();
        const fetch_cte = department.id ? util.fetch.put : util.fetch.post;

        const response = await fetch_cte(url, department).catch(this.handleSaveError);

        if (response) {
            toast.success(<ToastMessage
                icon={faCheckCircle}
                header="Save Successful"
                message={`Department [${department.description}] saved.`}
            />);
            this.setState({ show: false, saving: false });
            this.context.setFormOpened(false);
            this.resetForm();
            this.context.setFormOpened(false);
            this.props.onSaveCallback(response);
        }
    };

    handleSaveError = handleFormSaveError.bind(this);

    open = async (id) => {
        this.resetForm();
        this.setState({ show: true, loading: true });
        this.context.setFormOpened(true);

        let [department] = await Promise.all([
            (id ? util.fetch.js(ApiRoutes.department.byId(id)) : new Department())
        ]);

        this.setState({
            department,
            loading: false,
        });
    };

    async populateState() {

        this.setState((state) => ({
            loading: false,
        }));
    }

    resetForm() {
        this.setState({ formValidated: false });
    }

    render() {
        const {
            formValidated, validationMessage,
        } = this.state;
        const department = this.state.department;
        return (
            <SlideForm
                loading={this.state.loading}
                show={this.state.show}
                id="departmentForm"
                formIcon={faScrewdriver}
                formTitle={!!parseInt(department.id ?? 0) > 0 ? 'Edit Department' : 'Add Department'}
                ref={this.formRef}
                setIsValidated={(value) => { this.setState({ formValidated: value }); }}
                isValidated={formValidated}
                onSubmit={this.onSubmit}
                onClose={this.onClose}
                onSave={this.onSave}
                onDelete={this.onDelete}
                errors={this.state.errors}
                onClearErrors={this.onClearErrors}
                validationMessage={validationMessage}
            >

                <FormGroup>
                    <FormLabel
                        htmlFor="departmentNumber"
                        text="Department Number"
                        required
                    />
                    <Input
                        id="description"
                        name="department.departmentNumber"
                        value={department.departmentNumber ?? ''}
                        onChange={this.onChange}
                        type="text"
                        required
                    />
                    <ValidationErrorMessage>Department number is required.</ValidationErrorMessage>
                </FormGroup>

                <FormGroup>
                    <FormLabel
                        htmlFor="description"
                        text="Description"
                        required
                    />
                    <Input
                        id="description"
                        name="department.description"
                        value={department.description ?? ''}
                        onChange={this.onChange}
                        type="text"
                        required
                    />
                    <ValidationErrorMessage>Description is required.</ValidationErrorMessage>
                </FormGroup>
                
            </SlideForm>
        );
    }
}
